import { getDefaultHeader } from '../../../services/serviceAPIHelper';


export const getAirports = function () {
    let url = process.env.REACT_APP_API_URL + 'airports';

    return fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    })
        .then(response => {
            return response.json();
        }).catch(error => {
            console.log(error);
        });
};

export const deleteFlight = function (flightId) {
    let url = process.env.REACT_APP_API_URL + `flights/${flightId}`;

    return fetch(url, {
        method: 'DELETE',
        headers: getDefaultHeader(true)
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};


// WEBPACK FOOTER //
// ./src/components/Reservation/Flight/flightServices.js